<template>
  <div :class="s.wrap" v-if="showMenu">
    <ul>
      <li
        v-for="(item, i) in menuItems"
        :key="i">
        <router-link
          v-if="item.path !== '/logout'"
          :to="item.path"
          class="d-flex align-items-center flex-column">
          <div><i :class="[item.icon, s.icon]"/></div>
          <div class="fw-bold fs-sm mt-2">{{ item.label }}</div>
        </router-link>
        <div
          v-else
          @click="logout"
          class="d-flex align-items-center flex-column"
          style="cursor: pointer;">
          <div><i :class="[item.icon, s.icon]"/></div>
          <div class="fw-bold fs-sm mt-2">{{ item.label }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'side-menu',
  data() {
    return {
      menuItems: [
        {
          path: '/admin',
          label: 'ホーム',
          icon: 'fa-solid fa-house',
        },
        {
          path: '/admin/menus/',
          label: 'メニュー',
          icon: 'fa-solid fa-book',
        },
        {
          path: '/admin/menu-items/',
          label: 'メニュー商品',
          icon: 'fa-solid fa-burger-soda',
        },
        {
          path: '/admin/tablets/',
          label: 'デバイス',
          icon: 'fa-solid fa-tablet-screen-button',
        },
        {
          path: '/logout',
          label: 'ログアウト',
          icon: 'fa-solid fa-right-from-bracket',
        },
      ],
      showMenu: false,
    };
  },
  created() {
    this.handleMenu(this.$route);
  },
  watch: {
    $route(to) {
      this.handleMenu(to);
    },
  },
  methods: {
    logout(e) {
      e.preventDefault();
      this.$store.dispatch('user/login/logout');
    },
    handleMenu(to) {
      if (to.path.includes('admin')) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
  },
};
</script>

<style lang="scss" module="s">
$headerHeight: 15vh;
$itemWh: 15vw;

.wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-image: url('/img/menu/paperboard-texture.jpg');
  border-bottom: 2px solid rgba(152, 121, 89, 1);
  width: 100%;
  height: $headerHeight;
  display: flex;
  flex-direction: row;
  align-items: center;

  > ul {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    padding: 0 20px;
    height: 100%;

    > li {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      > * {
        width: $itemWh;
        height: 80%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        color: rgba(207, 185, 146, 1);
        cursor: pointer;
        transition: background-color 0.3s;
        border: 2px solid rgba(152, 121, 89, 1);
        border-radius: 8px;
        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        &:hover {
          background-color: rgba(152, 121, 89, 1);
        }
      }
    }
  }
}
.wrap > ul > li:nth-child(5) > * {
  // 通常時のスタイル
  background-color: #953217; // 例：薄い赤色
  color: #ffffff; // 例：濃い赤色
}

/* 5番目のliの子要素（router-link）のホバースタイル */
.wrap > ul > li:nth-child(5) > *:hover {
  background-color: #B03A2B; // 例：濃い赤色
}
.icon {
  font-size: 20px;
  margin: 0px;
}
:global(.container-lg) {
  padding-top: 5vh; /* ヘッダーの高さ分コンテンツを下げる */
  box-sizing: border-box;
}
:global(.no-admin-header) {
  padding-top: 0;
}
</style>
